/**
 * Main Application Component
 * 
 * Sets up the routing for the invoice editor application.
 * Routes:
 *   / - List all invoices
 *   /invoices/new - Create a new invoice
 *   /invoices/:id - View invoice details
 *   /invoices/:id/edit - Edit an invoice
 */
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import InvoicesList from './components/InvoicesList';
import InvoiceDetail from './components/InvoiceDetail';
import InvoiceForm from './components/InvoiceForm';
import { ErrorBoundary } from './components/common';

import './styles.css';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="page-container" style={{ minHeight: '100vh' }}>
          <Routes>
            {/* Invoice list - home page */}
            <Route path="/" element={<InvoicesList />} />
            
            {/* Create new invoice */}
            <Route path="/invoices/new" element={<InvoiceForm />} />
            
            {/* View invoice details */}
            <Route path="/invoices/:id" element={<InvoiceDetail />} />
            
            {/* Edit existing invoice */}
            <Route path="/invoices/:id/edit" element={<InvoiceForm />} />
          </Routes>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
